import { render } from "./NewUserTour.vue?vue&type=template&id=3a392a5c"
import script from "./NewUserTour.vue?vue&type=script&lang=js"
export * from "./NewUserTour.vue?vue&type=script&lang=js"

import "./NewUserTour.vue?vue&type=style&index=0&id=3a392a5c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__